import React from 'react';
import ListarPecas from '../components/ListarPecas/ListarPecas';

function PecasPage() {
  return <ListarPecas />;
}

export default PecasPage;
